<div class="container" [style.--selected]="selected" *transloco="let t">

  <div class="header" [ngClass]="{'readonly': readonly}">
    <app-icon-button
      [path]="'/assets/trash.svg'"
      [readonly]=readonly
      (clicked)="deleteImage()"
    ></app-icon-button>

    <div>
      <p>{{ t('POPUPS.IMAGE-GALLERY.UPLOADED-ON') }}</p>
      <p>{{displayCreatedAt()}}</p>
    </div>

    <app-icon-button
      [path]="'/assets/closebutton.svg'"
      (clicked)="closeEvent.emit(true)"
    ></app-icon-button>
  </div>

  <app-icon-button
    *ngIf="selected > 0"
    class="prev"
    [path]="'/assets/arrow_right.svg'"
    (clicked)="prev()"
  ></app-icon-button>

  <div class="image-gallery">
    <div *ngFor="let image of this.galleryService.images" class="image-container">
      <img src={{image.data}}>
    </div>
  </div>

  <app-icon-button
    *ngIf="selected < this.galleryService.images.length - 1"
    class="next"
    [path]="'/assets/arrow_right.svg'"
    (clicked)="next()"
  ></app-icon-button>

  <div class="navigation">
    <div *ngFor="let item of this.galleryService.images; let i = index" class="selector" (click)="select(i)"
         [ngClass]="{'selected': selected === i}"></div>
  </div>

  <div class="overlay"></div>

</div>
